import { ToursSearch } from 'package-types';

export class AvailableOffersState {
  unfilteredOffers: ToursSearch.Offer[] = [];
  offers: ToursSearch.Offer[] = [];
}
